/* eslint no-param-reassign: 0 */

import getUuid from 'widget/helpers/uuid';
import { MESSAGE_STATUS, MESSAGE_TYPE } from 'shared/constants/messages';

export default () => {
  if (!Array.prototype.last) {
    Object.assign(Array.prototype, {
      last() {
        return this[this.length - 1];
      },
    });
  }
};

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const isJSONValid = value => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

export const getTypingUsersText = (users = []) => {
  const count = users.length;

  if (count === 1) {
    const [user] = users;
    return window.WOOT.$root.$t('CONVERSATION.ONE_PERSON_IS_TYPING', {
      username: user.name,
    });
  }

  if (count === 2) {
    const [first, second] = users;
    return window.WOOT.$root.$t('CONVERSATION.TWO_PERSON_ARE_TYPING', {
      username1: first.name,
      username2: second.name,
    });
  }

  const [user] = users;
  const rest = users.length - 1;
  return window.WOOT.$root.$t('CONVERSATION.MORE_PERSON_ARE_TYPING', {
    username: user.name,
    count: rest,
  });
};

export const createPendingMessage = data => {
  const timestamp = Math.floor(new Date().getTime() / 1000);
  const tempMessageId = getUuid();
  const { message, file } = data;
  const tempAttachments = [{ id: tempMessageId }];
  const pendingMessage = {
    ...data,
    content: message || null,
    id: tempMessageId,
    echo_id: tempMessageId,
    status: MESSAGE_STATUS.PROGRESS,
    created_at: timestamp,
    message_type: MESSAGE_TYPE.OUTGOING,
    conversation_id: data.conversationId,
    attachments: file ? tempAttachments : null,
  };

  return pendingMessage;
};

// d99d
export const isFileExtAllowed = (fileName, fileTypesAllowed) => {
  if (!fileName || !fileTypesAllowed) return true;

  const allowedTypes = fileTypesAllowed
    .replace(/\w+\//ig, '')
    .replace(/,\.jpg/, ',.jpg,.jpeg')
    .replace(/,/g, '|')
    .replace(/ |\./g, '')
    .replace(/\*/g, '\\w+') // if * then we allow all for now
  const extPattern = new RegExp(`\\.(${allowedTypes})$`, 'i')
  return extPattern.test(fileName)
}
// .

export const convertToAttributeSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '_');
};

export const convertToCategorySlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

export const convertToPortalSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

export const containsHebrew = text => {
  const hebrewRegex = /[\u0590-\u05FF]/;
  return hebrewRegex.test(text);
};
